
import { Options, prop, Vue } from "vue-class-component";
import LpButton from "@/app/ui/components/lp-button/index.vue";

class Props {
  modelValue = prop<string | null>({
    default: null
  });
  placeholder = prop<string>({
    default: ""
  });
  dropdownTitle = prop<string>({
    default: ""
  });
  options = prop<Array<{ name: string; value: string }>>({
    default: []
  });
  iconLeft = prop<string>({
    default: ""
  });
}

@Options({
  components: {
    LpButton
  },
  emits: ["update:modelValue", "change"]
})
export default class DropdownFilter extends Vue.with(Props) {
  isOpen = false;

  get selectedLabel() {
    const selected = this.options.find((opt) => opt.value === this.modelValue);
    return selected ? selected.name : this.placeholder;
  }

  get isActive() {
    return this.isOpen || (this.modelValue !== null && this.modelValue !== "");
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: any) {
    this.$emit("update:modelValue", option.value);
    this.$emit("change", option.value);
    this.isOpen = false;
  }
}
